<template>
  <div class="cwTextInputWrapper" v-show="isVisible">
    <div class="form-group" :class="{ disabled: isDisabled }">
      <p>{{ getCactusString(cmpConfig.component.decorator.label_static) }}</p>
      <div class="input-group">
        <span class="input-group-addon" v-if="cmpConfig.component.decorator.label_prefix">{{
          cmpConfig.component.decorator.label_prefix[1]
        }}</span>

        <input
          :type="inputType"
          :step="getSteps"
          :placeholder="getCactusString(cmpConfig.component.decorator.label_hint)"
          v-model="inputData"
          v-on:change="valueChanged"
          v-if="inputType === 'number'"
        />

        <input
          :type="inputType"
          :placeholder="getCactusString(cmpConfig.component.decorator.label_hint)"
          v-model="inputData"
          v-on:change="valueChanged"
          v-if="inputType === 'text'"
        />

        <span>{{ getCactusString(cmpConfig.component.decorator.label_unit) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _find from 'lodash/find';
import expertviewMixin from './experviewMixin';

export default {
  name: 'cwTextInputWrapper',
  mixins: [expertviewMixin],
  props: {
    cmpConfig: {
      type: Object,
      default: () => {},
      required: true
    },
    fwParams: {
      type: Array,
      default: () => [],
      required: true
    },
    valueSet: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      inputData: undefined
    };
  },
  created() {
    this.$log.debug('cwTextInputWrapper::created()', this.cmpConfig);

    this.applyRules();

    this.inputData = this.applyTransformations(this.valueFromFw);

    if (this.inputType === 'number')
      this.inputData = Number(this.inputData).toFixed(this.cmpDecimals);

    this.valueChanged(this.inputData);
  },
  computed: {
    ...mapGetters(['latestAppData']),

    listContent() {
      let valKey = 'default';
      if (this.cmpConfig.rule_subscriber && this.valuesWithRules) {
        valKey = this.cmpConfig.rule_subscriber[0].rule[0] || 'default';
      }

      return this.cmpConfig.value[valKey];
    },

    valueFromFw() {
      let fwParams = this.getFwApp();

      return this.getAppValue(fwParams.app, fwParams.param) || this.defaultValue;
    },

    getSteps() {
      return (this.cmpConfig.value.default.restrictions || {}).step || 1;
    },

    inputType() {
      let inputType = _find((this.fwParams || [])[0], 'type') || '';
      if (inputType.type.toLowerCase() === 'string') return 'text';
      return 'number';
    },
    /**
     * Check if the component is enable or editable
     * !enable & editable = true -> `disabled`
     * !enable & !editable = false -> `enabled`
     */
    isDisabled() {
      const comp = this.cmpConfig.component;
      const disabled = [comp].reduce(
        (sum, next) => (sum && !next.enabled) || (sum && next.editable),
        true
      );
      return disabled;
    }
  },
  methods: {
    valueChanged() {
      let fwApp = this.getFwApp();
      let dataObj = this.getDataObj(fwApp, this.inputData);

      this.$log.debug('cwTextInputWrapper::valueChanged', dataObj);
      this.setExpertViewParams(dataObj);
    },

    getDataObj(fwApp, inputObj) {
      const baseObj = {
        app: fwApp.app,
        parameter: fwApp.param
      };

      if (this.inputType === 'text') {
        return {
          ...baseObj,
          value: inputObj
        };
      }

      let value = this.applyReverseTransformations(parseFloat(this.inputData));

      return {
        ...baseObj,
        value: value
      };
    }
  }
};
</script>

<style scoped lang="scss">
.cwTextInputWrapper {
  background: rgba(190, 205, 215, 0.2);

  .form-group {
    height: 58px;
    padding: 16px 0 0 16px;
    text-align: left;

    p {
      @include textSmall;
      color: $bluey-grey;
      padding-bottom: 8px;
    }

    input {
      border: none;
      text-align: right;
      padding: 10px 0 0 18px;
      @include textCharts;
      color: $petrol;
      width: 50px;
      background: transparent;

      &[type='text'] {
        width: auto;
        text-align: left;
      }
    }

    span {
      padding-left: 3px;
      @include textCharts;
      color: $petrol;
    }

    &.disabled {
      background-color: #becdd7;

      p {
        color: #879baa;
      }

      input {
        background-color: transparent;
      }
    }
  }
}
</style>
